<template>
  <div class="phone-list-component">
    <span class="info-item-label">{{ `${label}:` }}</span>
    <ul ref="phoneListRef" class="info-item-data-large">
      <li v-for="(subItem, subIndex) in data" :key="subIndex">
        <span class="subitem-name">{{ subItem.name }}</span>
        <div v-if="subItem.phone" class="phone-container">
          <a :href="`tel:${subItem.phone}`" class="phone-link">
            <span :class="[icon.phone, 'phone-icon']"></span>
            <span class="phone-number">{{ subItem.phone }}</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { Icons } from '@/icons/icons'
import { ref, onMounted, defineProps, defineEmits } from 'vue'

interface DataItem {
  name: string
  phone?: string
}

// PROPS
const props = defineProps<{
  label: string
  data: DataItem[]
  index: number
}>()

const icon = {
  phone: Icons.CALL
}

// EMITS
const emit = defineEmits(['setRef'])

// REFS
const phoneListRef = ref<HTMLElement | null>(null)

// HOOKS
onMounted(() => {
  if (phoneListRef.value) {
    emit('setRef', phoneListRef.value, props.index)
  }
})
</script>

<style lang="scss" scoped>
.phone-list-component {
  display: flex;
  width: 100%;
  align-items: center;
  padding: $spacing-xxs 0;
  background-color: transparent;

  .info-item-label {
    @include milano-bold-16;
    color: $neutral-grey-800;
    padding: 0 $spacing-xxs;
    margin-right: $spacing-xs;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .info-item-data-large {
    @include milano-regular-14;
    color: $neutral-grey-800;
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: none;
    width: 100%;
    display: inline;
    padding-left: 0 !important;

    li {
      display: inline;
      white-space: nowrap;
      align-items: center;
      height: 100%;

      &:not(:last-of-type)::after {
        content: '·';
        margin-right: 6px;
      }

      .subitem-name {
        @include milano-regular-14;
        color: $neutral-grey-800;
      }
    }

    .phone-container {
      display: inline-flex;
      font-size: 10px;
      align-items: center;
      justify-content: center;
      color: $neutral-grey-800;
      border-radius: $spacing-xxs;
      border: 0.5px solid $main-400;
      padding: 4px;
      height: 20px;
      margin: 0 6px;

      .phone-link {
        display: inline-flex;
        align-items: center;
        text-decoration: none;
        color: inherit;

        .phone-icon {
          margin-right: 4px;
          font-size: 12px;
        }

        .phone-number {
          @include milano-regular-12;
          padding-top: 1px;
        }
      }
    }
  }
}
</style>
